import { RBAC } from "./rbac.reducer";

export const selectRbac = (state) => state[RBAC];
